import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["syncModal", "supplierName", "supplierId", "syncForm"]

  connect() {
    // Set the form action when the controller connects
    if (this.hasSyncFormTarget) {
      this.syncFormTarget.action = "/admin/suppliers/sync"
    }
  }

  openSyncModal(event) {
    const button = event.currentTarget
    const supplierId = button.dataset.supplierId
    const supplierName = button.dataset.supplierName

    // Update modal content
    this.supplierIdTarget.value = supplierId
    this.supplierNameTarget.textContent = supplierName

    // Show modal
    this.syncModalTarget.classList.remove("hidden")
  }

  closeSyncModal() {
    this.syncModalTarget.classList.add("hidden")
  }
}